import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Clickable from '../../UI/Clickable/Clickable';
import classes from './SectionPreview.module.css';
import { parseIndex } from '../../../utils';

const SectionPreview = ({
  name,
  link,
  buttonLabel,
  color,
  imageSrc,
  index,
  defaultSubsection,
}) => {
  const history = useHistory();
  return (
    <Clickable
      testId="section-background"
      onClick={() =>
        history.push(
          `${link}/${defaultSubsection !== null ? defaultSubsection : ''}`
        )
      }
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0) 30%, ${color} 100%), url(${process.env.PUBLIC_URL}${imageSrc})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'norepeat',
        backgroundSize: 'cover',
        height: '64vh',
        position: 'relative',
      }}
      className={classes.sectionPreview}
    >
      <div className={classes.boxInformation}>
        <p className={classes.index}>{parseIndex(index)}</p>
        <p className={classes.name}>{name}</p>
        <p className={classes.button}>{buttonLabel}</p>
      </div>
    </Clickable>
  );
};

SectionPreview.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  defaultSubsection: PropTypes.string,
};

SectionPreview.defaultProps = {
  defaultSubsection: '',
};

export default SectionPreview;
